import _ from "lodash";
const names = [
  "aditi",
  "arpita",
  "deepali",
  "rupali",
  "meghna",
  "shobhna",
  "mohini",
  "kamini",
  "yamini",
  "nupur",
  "meher",
  "pallavi",
  "poonam",
  "sonam",
  "yashvi",
  "jahnavi",
  "myra",
  "shayra",
  "kanika",
  "deepika",
  "priyanka",
  "richa",
  "saloni",
  "sonali",
  "kaavya",
  "ankita",
  "bhawna",
  "dolly",
  "pooja",
  "kriti",
  "meenal",
  "preeti",
  "rajul",
  "parul",
  "surbhi",
  "swati",
  "kavita",
  "sunita",
  "laxmi",
  "sapna",
  "rashmi",
  "kajul",
  "anamika",
  "anshika",
  "riddhi",
  "vaishnavi",
  "madhurima",
  "nirmala",
];

const bgColor = [
  "#FFCD4D",
  "#F65858",

  "#29E23A",
  "#223ED6",

  "#C951FF",
  "#F65858",

  "#223ED6",
  "#FFCD4D",

  "#223ED6",
  "#29E23A",

  "#C951FF",
  "#FFCD4D",
];

export const fnId = "11862";

export const getVisualFNMix = (isFaceData, dispatchHelper, testType) => {
  // means !!test is CALIBRATION or DEMO
  const isShortTest = !!testType;
  if (isFaceData) {
    return { ...isFaceData, dummyMathQues: dummyMathQues(isShortTest) };
  } else {
    let faceArray = getFaceArr(isShortTest);
    const groupFaces = faceArray.reduce((acc, curr, i) => {
      if (!(i % 4)) {
        // if index is 0 or can be divided by the `size`...
        acc = [
          ...acc,
          { faces: faceArray.slice(i, i + 4), id: `${fnId}${i + 1}` },
        ];
        // acc.push(); // ..push a chunk of the original array to the accumulator
      }
      return acc;
    }, []);

    dispatchHelper({ type: "FACE_DATA", payload: { faceArray, groupFaces } });

    return { faceArray, groupFaces, dummyMathQues: dummyMathQues(isShortTest) };
  }
};

const getFaceArr = (isShortTest) => {
  const onlyFaceArr = isShortTest
    ? _.sampleSize(names, 4)
    : _.sampleSize(names, 12);
  let faceArr = onlyFaceArr.map((faceName, index) => {
    return { faceName, bgColor: bgColor[index] };
  });
  faceArr = faceArr.map((faceArray, index) => {
    const shuffledName = _.shuffle(onlyFaceArr);
    const correctPos =
      shuffledName.findIndex((faceName) => faceName === faceArray.faceName) + 1;

    // const correctPosIn = shuffledName.indexOf(faceArray.faceName) + 1;
    // console.log(correctPosIn);

    return {
      names: faceArray.faceName,
      id: `${fnId}${index + 1}`,
      resp_time: 15,
      section_name: "FACE-NAME MIX",
      test_format: "visual_facename_mix",
      link1_type: "image",
      link1: require(`../../assets/img/faceNameMix/${faceArray.faceName}.png`),
      difficulty_level: 1,
      bgColor: faceArray.bgColor,
      score_count: "total",
      choice_1: shuffledName[0],
      choice_2: shuffledName[1],
      choice_3: shuffledName[2],
      choice_4: shuffledName[3],
      choice_5: shuffledName[4],
      choice_6: shuffledName[5],
      choice_7: shuffledName[6],
      choice_8: shuffledName[7],
      choice_9: shuffledName[8],
      choice_10: shuffledName[9],
      choice_11: shuffledName[10],
      choice_12: shuffledName[11],
      correct_choice: `${correctPos}`,
      que_title1_type: "text",
      test_id: 190425225045,
    };
  });

  return faceArr;
};

const dummyMathQues = (isShortTest) =>
  isShortTest
    ? [
        {
          id: "11862",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 3 * 5 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "16",
          choice_2: "15",
          choice_3: "18",
          choice_4: "14",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11859",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 12 + 6 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "14",
          choice_2: "18",
          choice_3: "11",
          choice_4: "13",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11861",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 5 * 2 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "10",
          choice_2: "5",
          choice_3: "8",
          choice_4: "11",
          choice_5: "",
          choice_6: "",
          correct_choice: "1",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11856",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 4 + 7 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "2",
          choice_1: "10",
          choice_2: "11",
          choice_3: "9",
          choice_4: "8",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
      ]
    : [
        {
          id: "11862",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 3 * 5 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "16",
          choice_2: "15",
          choice_3: "18",
          choice_4: "14",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11853",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 6 - 2 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "1",
          choice_1: "6",
          choice_2: "5",
          choice_3: "4",
          choice_4: "1",
          choice_5: "",
          choice_6: "",
          correct_choice: "3",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11854",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 9 - 1 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "1",
          choice_1: "6",
          choice_2: "4",
          choice_3: "5",
          choice_4: "8",
          choice_5: "",
          choice_6: "",
          correct_choice: "4",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11855",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 8 - 4 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "1",
          choice_1: "5",
          choice_2: "7",
          choice_3: "9",
          choice_4: "4",
          choice_5: "",
          choice_6: "",
          correct_choice: "4",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11859",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 12 + 6 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "14",
          choice_2: "18",
          choice_3: "11",
          choice_4: "13",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11861",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 5 * 2 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "10",
          choice_2: "5",
          choice_3: "8",
          choice_4: "11",
          choice_5: "",
          choice_6: "",
          correct_choice: "1",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11858",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 14 + 4 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "2",
          choice_1: "16",
          choice_2: "18",
          choice_3: "17",
          choice_4: "15",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11856",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 4 + 7 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "2",
          choice_1: "10",
          choice_2: "11",
          choice_3: "9",
          choice_4: "8",
          choice_5: "",
          choice_6: "",
          correct_choice: "2",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11857",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 17 + 5 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "2",
          choice_1: "20",
          choice_2: "19",
          choice_3: "22",
          choice_4: "10",
          choice_5: "",
          choice_6: "",
          correct_choice: "3",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
        {
          id: "11860",
          test_id: "190425225052",
          section_id: "92",
          choice_type: "single_choice",
          que_hint: "",
          que_title1: "Calculate 4 * 4 = ?",
          que_title1_type: "text",
          que_title2: "",
          link1: "",
          link1_type: "",
          link2: "",
          link2_type: "",
          grade: "2",
          difficulty_level: "3",
          choice_1: "15",
          choice_2: "10",
          choice_3: "11",
          choice_4: "16",
          choice_5: "",
          choice_6: "",
          correct_choice: "4",
          correct_text: "",
          resp_time: "15",
          active: "Y",
          created_date: "0000-00-00 00:00:00",
          created_by: "1",
          test_format: "dummy-test",
          section_name: "FACE NAME QUANT",
          intro1:
            "<ol>\r\n <li> Tap to start. Tap again when the colour of the screen changes. </li>\r\n<li>You have five attempts to record your fastest response time. </li>\r\n <li>Total Test Duration – 1.5 minutes</li>\r\n <li>Time to answer each question/attempt – 10 seconds</li>\r\n <li>Respond as fast as you can</li>\r\n <li>Attempt as many as you can.</li>\r\n</ol>",
          intro2:
            "Your test will end if –<br>\r\n<ol>\r\n <li>You minimize the app or go away from the test screen.</li>\r\n <li>You do not answer 5 questions in a row.</li>\r\n</ol>\r\n<br>Feel free to make a guess as there are no negative marks.<br><br>",
          info:
            "Tap to start. Tap again when the colour of the screen changes. You have five attempts to record your fastest response time.",
          info_audio: "",
          info_video: "",
          replay: "Y",
          score_rule: "Rule1",
          match_type: "exact",
          match_order: "N",
          score_count: "single",
          match_hint: "N",
        },
      ];
